/* Conecta names each brand's catch-all model "Otros Modelos <brand>", with a single version of
   the same name. */
const isCatchAllModel = (model) => /^\s*otros\s+modelos/i.test(model.name);

/* The versions offered for a model: its own and the brand's catch-all, so a vehicle whose
   version is missing from the catalog keeps its model ("Silverado" with the "Otros Modelos
   Chevrolet" version). `brandModels` are the models of the selected brand. */
const modelVersionOptions = (brandModels, versions, modelId) => {
  if (modelId === '') return [];

  const catchAllModelIds = brandModels.filter(isCatchAllModel).map((model) => model.id);
  const offeredModelIds = [modelId, ...catchAllModelIds];

  return versions.filter((version) => offeredModelIds.includes(version.modelId));
};

export default modelVersionOptions;
